<template>
  <v-checkbox v-model="value" :label="label" :disabled="disabled"></v-checkbox>
</template>

<script>
import fieldMixin from '@/mixins/LeanField';

export default {
  name: 'LeanBoolean',
  mixins: [fieldMixin],
  data() {
    return {
      // assure that we always have a boolean value
      value: !!JSON.parse(JSON.stringify(this.initialValue))
    };
  }
};
</script>
